import { createAction } from '@reduxjs/toolkit'
import { createPromiseAction } from 'redux-saga-promise-actions'

export const getChats = createAction('GET_CHATS')

// utilizar o redux-thunk para enviar a info que esta em um slice (reducer) diferente do atual
export const getChatsThunk = dataFromComponent => (dispatch, getState) => {
  const state = getState()
  const currentRoomType = state.room_menu.current_room_type
  const finalPayload = {
    ...dataFromComponent,
    room_type: currentRoomType
  }
  dispatch(getChats(finalPayload))
}

export const clearPrivateRooms = createAction('CLEAR_PRIVATE_ROOMS')
export const getPrivateRoomsSuccessful = createAction(
  'GET_PRIVATE_ROOMS_SUCCESSFUL'
)
export const setPrivateRoomsOrder = createAction('SET_PRIVATE_ROOMS_ORDER')
export const setGroupRoomsOrder = createAction('SET_GROUP_ROOMS_ORDER')
export const setMediationRoomsOrder = createAction('SET_MEDIATION_ROOMS_ORDER')

export const clearGroupRooms = createAction('CLEAR_GROUP_ROOMS')
export const getGroupRoomsSuccessful = createAction(
  'GET_GROUP_ROOMS_SUCCESSFUL'
)

export const clearMediationRooms = createAction('CLEAR_MEDIATION_ROOMS')
export const getMediationRoomsSuccessful = createAction(
  'GET_MEDIATION_ROOMS_SUCCESSFUL'
)

export const getChatsSuccessful = createAction('GET_CHATS_SUCCESSFUL')
export const getChatsFailure = createAction('GET_CHATS_FAILURE')

export const createChatRSPA = createPromiseAction('rspa: CREATE_CHAT')()
export const createChatSuccessful = createAction('CREATE_CHAT_SUCCESSFUL')
export const createChatFailure = createAction('CREATE_CHAT_FAILURE')

export const getChatById = createAction('GET_CHAT_BY_ID')
export const getChatByIdSuccessful = createAction('GET_CHAT_BY_ID_SUCCESSFUL')
export const getChatByIdFailure = createAction('GET_CHAT_BY_ID_FAILURE')

export const deleteChat = createAction('DELETE_CHAT')
export const deleteChatSuccessful = createAction('DELETE_CHAT_SUCCESSFUL')
export const deleteChatFailure = createAction('DELETE_CHAT_FAILURE')

export const createMessageRSPA = createPromiseAction('rspa: CREATE_MESSAGE')()
export const getMessagesRSPA = createPromiseAction('rspa: GET_MESSAGES')()
export const getInterventionMessagesRSPA = createPromiseAction(
  'rspa: GET_INTERVENTION_MESSAGE'
)()
export const getMessagesWithoutRoomRSPA = createPromiseAction(
  'rspa: GET_MESSAGES_WITHOUT_ROOM'
)()
export const getRoomsRSPA = createPromiseAction('rspa: GET_ROOMS')()
export const getRoomsByIdRSPA = createPromiseAction('rspa: GET_ROOM_BY_ID')()

export const editMessageRSPA = createPromiseAction('rspa: EDIT_MESSAGE')()
